<template>
	<div class="page">
		<div class="container-fluid">
			<div style="display: flex;align-items: flex-end;">
				<span style="font-size: 20px;color:#fff">销售统计</span>
			</div>
			<span style="margin-top: 10px;font-size: 14px;color:#fff">sell count</span>
		</div>
		<SellCountList></SellCountList>
		<!-- <ListMsg ref="list" v-if="type==='list'"></ListMsg>
		<sendMsg v-if="type==='add'" @back="back"></sendMsg> -->
	<!-- 	
		<AddCard v-if="type==='add'" @back="back"></AddCard> -->
	</div>
</template>

<script>
	import SellCountList from '../../components/sell_count/SellCountList.vue'
	export default {
		components:{
			SellCountList
		},
		data() {
			return {
				
			}
		}
	}
</script>

<style>
	.page {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		display: flex;
		flex-direction: column;
	}

	.page .container-fluid {
		padding: 45px 25px;
		display: flex;
		flex-direction: column;
		background-color: rgb(66, 75, 79);
		position: relative;
		color: #e6e6e6;
	}
	.page .container-fluid .inner-btn{
		width: 120px;
		height: 40px;
		border: 1px solid #ccc;
		position: absolute;
		top: 40px;
		right: 20px;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		cursor:pointer;
	}

</style>